import { Component, Input, OnInit } from '@angular/core';
import { TypeBagsWeight } from '@app/enums';

/**
 * Componente para mostrar el conteo de maletas en el pie de página de la selección de equipaje.
 */
@Component({
    selector: 'am-bags-footer-count-bags',
    templateUrl: './am-bags-footer-count-bags.component.html',
    styleUrls: ['./am-bags-footer-count-bags.component.scss'],
    standalone: false
})
export class AmBagsFooterCountBagsComponent implements OnInit {

   /**
   * Peso de la maleta seleccionada. El valor proviene del enum `TypeBagsWeight`.
   * 
   * @type {TypeBagsWeight}
   * @default TypeBagsWeight._20KG
   */
   @Input() bagWeight: TypeBagsWeight = TypeBagsWeight._20KG;

   /**
    * Número total de maletas seleccionadas.
    * 
    * @type {number}
    * @default 0
    */
   @Input() count: number = 0;
 
   /**
    * Etiqueta generada dinámicamente para mostrar el peso de las bolsas en la interfaz.
    * 
    * @type {string}
    */
   labelWeight: string = '';

  constructor() { }

  ngOnInit(): void {
    this.init();
  }

  init(){
    this.labelWeight = 'bagsSelection.table.footer.'
    this.labelWeight += this.bagWeight == TypeBagsWeight._20KG ? 'bags20Kg' : this.bagWeight == TypeBagsWeight._25KG? 'bags25Kg' : 'bags32Kg';
  }

}
